import {createBrowserHistory} from 'history'
import React from "react"
import {connect, Provider} from 'react-redux'
import {Redirect, Route, Router as BrowserRouter, Switch} from "react-router-dom"
import {store} from 'store'
import Login from "views/Auth/Login"
import {hasFlag} from "../filters"
import AcceptAgb from "../views/Auth/AcceptAgb"
import App from "../views/App"
import Dashboard from "../views/Dashboard/Dashboard"
import SpeedAuktionPage from "../views/SpeedAuktion/SpeedAuktionPage"
import ClaimedVehiclesPage from "../views/ClaimedVehicles/ClaimedVehiclesPage"
import {Auction, User} from "../domain-models"
import {GlobalState} from "../state"
import NotFound from "../components/NotFound"
import Profile from "../views/Settings/Profile"
import Auctions from "../views/Auctions/Auctions"
import _ from 'lodash'
import {showNewlyArrived} from "../redux/actions"
import RequestPasswordRequest from "../views/Auth/RequestPasswordReset"
import ResetPassword from "../views/Auth/ResetPassword"
import Impersonation from "../views/Auth/Impersonation"

export const history = createBrowserHistory({
  basename: window.app.basename + '/',
})

type RoutesProps = {
  user: User
}

export const Router = () => {
  return (
    <Provider store={store}>

      <ConnectedRoutes/>

    </Provider>
  )
}

const openAuctions = async (auctions: Array<Auction>) => {
  if (history.location.pathname !== '/') {
    history.replace('/')
  }

  await store.dispatch(showNewlyArrived(auctions))
}

const Routes = ({user}: RoutesProps) => {

  const speedAuktion = window.app?.user?.authority?.mod_speed_auction_claim

  if (speedAuktion) {
    return (
      <BrowserRouter history={history} key={history.location.hash}>

        <Switch>
          <Route exact path='/dashboard' render={props => <App {...props}><Dashboard/></App>}/>

          <Route exact path='/speed-auktion' render={props => <App {...props}><SpeedAuktionPage/></App>}/>

          <Route exact path='/claimed-vehicles' render={props => <App {...props}><ClaimedVehiclesPage {...props}/></App>}/>

          <Route exact path="/settings" render={props => <App {...props}><Profile/></App>}/>

          <Route render={() => <Redirect to='/speed-auktion'/>}/>
        </Switch>

      </BrowserRouter>
    )
  }

  return (
    <BrowserRouter history={history} key={history.location.hash}>

      <Switch>

        <Route exact path='/request-password-reset' render={() => user && !_.isEmpty(user) ? <Redirect to='/'/> : <RequestPasswordRequest/>}/>

        <Route exact path='/password/reset/:token/:username' render={(props) => user && !_.isEmpty(user) ? <Redirect to='/'/> : <ResetPassword {...props} />}/>

        <Route exact path='/login' render={() => {
          if (!user || _.isEmpty(user)) return <Login/>
          
          if (!window.app?.user) {
            return <Redirect to='/'/>
          }
          
          const agbAccepted = hasFlag(window.app.user.employee, 'MetaFlags', 2)
          const agbConfigured = window.app?.settings?.agbUrl || window.app?.settings?.agbUrls
          const hasSpeedAuktionPermission = window.app.user?.authority?.mod_speed_auction_claim
          return <Redirect to={(agbAccepted || !agbConfigured || hasSpeedAuktionPermission) ? '/' : '/accept-agb'}/>
        }}/>

        <Route exact path='/impersonation' render={() => window.app.user && window.app.user.domain === 'ars' && window.app.user.authority && window.app.user.authority.superuser ? <Impersonation/> : <NotFound/>}/>

        <Route exact path='/accept-agb' render={() => {
          const agbAccepted = window.app.user && hasFlag(window.app.user.employee, 'MetaFlags', 2)
          const agbConfigured = window.app?.settings?.agbUrl || window.app?.settings?.agbUrls
          // Redirect to home if AGB accepted OR if no AGB document configured
          return (agbAccepted || !agbConfigured) ? <Redirect to='/'/> : <AcceptAgb/>
        }}/>

        <Route exact path='/' render={props => <App {...props}><Auctions/></App>}/>

        <Route exact path='/dashboard' render={props => <App {...props}><Dashboard/></App>}/>

        <Route exact path="/settings" render={props => <App {...props}><Profile/></App>}/>

        <Route path='/auctions/:auctionId/pickup-code/print' render={() => {
          window.close();
          return (<div/>)
        }}/>

        <Route exact path='/:auctionId' render={props => {
          // Only treat numeric paths as auction IDs; other single-segment paths
          // (e.g. /dashboard) should fall through to NotFound
          if (!/^\d+$/.test(props.match.params.auctionId)) {
            return <NotFound/>
          }

          history.replace('/')

          return (<App {...props}><Auctions match={props.match}/></App>)
        }}/>

        <Route exact path='/auctions/:auctionId' render={props => {
          history.replace('/')

          return (<App {...props}><Auctions match={props.match}/></App>)
        }}/>

        <Route render={() => <NotFound/>}/>

      </Switch>

    </BrowserRouter>
  )
}


const ConnectedRoutes = connect((state: GlobalState) => ({
  user: state.user
}))(Routes)